<template>
  <div
    v-if="researchAdvisor.id"
  >
    <b-card no-body>
      <create @refetchData="refetchData" />
    </b-card>
  </div>
  <div
    v-else
    class="d-flex justify-content-center"
  >
    <b-spinner
      key="primary"
      variant="primary"
    />
  </div>
</template>

<script>
import { BSpinner, BCard } from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import store from '@/store'
import researchAdvisorModule from '@/store/research-advisor'
import permission from './permission'
import Create from './add/Create.vue'

export default {
  components: {
    BSpinner,
    Create,
    BCard,
  },
  computed: {
    researchAdvisor() {
      return this.$store.state[this.MODULE_NAME].researchAdvisor
    },
    user() {
      return this.researchAdvisor.user
    },
  },
  mounted() {
    this.refetchData()
  },
  methods: {
    refetchData() {
      this.$store.commit(`${this.MODULE_NAME}/FRESH`)
      this.$store.dispatch(`${this.MODULE_NAME}/get`, this.$route.params.id)
    },
  },
  setup() {
    const MODULE_NAME = 'researchAdvisor'
    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, researchAdvisorModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
    })
    return {
      MODULE_NAME,
      ...permission(),
    }
  },
}
</script>

<style scoped>

</style>
